export default {
  name: 'xiangxi',
  adcode: '433100',
  mapName: '湘西土家族苗族自治州',
  geoJsonPath: 'hunanmap/433100.json',
  backgroundImage: {
    png: '湘西州_433100.png',
    webp: '湘西州_433100.webp'
  },
  echartsMapStyle: {
    width: '937px',
    height: '545px',
    marginTop: 'auto',
    marginBottom: '162px',
  },
  imageSize: {
    width: 4324,
    height: 2514
  },
  // 地图特殊配置：背景图片适配参数
  specialConfig: {
    // 独立调整参数
    layoutSizeAdjustment: {
      enabled: true,
      multiplier: 1.71, // 布局尺寸调整倍数（微调）
      minSize: 400,     // 最小布局尺寸
      maxSize: 1200     // 最大布局尺寸
    },
    aspectScaleAdjustment: {
      enabled: true,
      multiplier: 0.98, // 宽高比调整倍数（微调）
      minScale: 0.5,    // 最小缩放比例
      maxScale: 2.0     // 最大缩放比例
    },
    // 位置偏移补偿
    positionOffset: {
      x: 0.005,  // X轴偏移百分比
      y: 0.001  // Y轴偏移百分比
    }
  },
  // 区县列表
  districts: ['吉首市', '泸溪县', '凤凰县', '花垣县', '保靖县', '古丈县', '永顺县', '龙山县'],
  // 区县坐标映射（用于tooltip定位与涟漪效果）
  cityCoords: {
    // 市区参考坐标（用于兜底展示）
    '吉首市区': [109.738273, 28.314827],
    '湘西土家族苗族自治州': [109.738273, 28.314827],
    // 区县坐标（来自 433100.json center）
    '吉首市': [109.368273, 28.489827],
    '泸溪县': [109.204428, 28.280516],
    '凤凰县': [109.069191, 28.760352],
    '花垣县': [109.489063, 28.826352],
    '保靖县': [109.781445, 28.640605],
    '古丈县': [109.649592, 28.276973],
    '永顺县': [110.073292, 28.318068],
    '龙山县': [110.255189, 28.773438]
  },
  // 区县名称标准化
  normalizeName: (name) => {
    if (!name) return ''
    const s = String(name).trim()
    // 州府城区统一为“吉首市区”
    if (['湘西土家族苗族自治州', '湘西自治州', '湘西州', '吉首市', '吉首市区'].includes(s)) return '吉首市'
    return s
  },
  // 区县与adcode映射
  cityAdcodeMap: {
    '吉首市': '433101',
    '泸溪县': '433122',
    '凤凰县': '433123',
    '花垣县': '433124',
    '保靖县': '433125',
    '古丈县': '433126',
    '永顺县': '433127',
    '龙山县': '433130'
  }
}